<template>
  <div>
    <app-contentpageheader>
      <b-img
        slot="entrySectionImage"
        fluid
        alt="Responsive image"
        :src="backgroundImg"
      />
      <h3 slot="entrySectionText">Realizacje</h3>
    </app-contentpageheader>
    <app-projects />

    <app-footer />
  </div>
</template>
<script>
import ContentPageHeader from "../components/common/ContentPageHeader.vue";
import Footer from "../components/common/Footer.vue";
import Projects from "../components/projects/Projects.vue";

export default {
  data() {
    return {
      backgroundImg: require("../assets/projects/kolekcja.jpg")
    };
  },
  components: {
    "app-footer": Footer,
    "app-projects": Projects,
    "app-contentpageheader": ContentPageHeader
  }
};
</script>
